"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleModelsMockCreator = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const Kette_1 = require("./kette/Kette");
const KetteConfigurationBuilder_1 = require("./kette/KetteConfigurationBuilder");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const AE_1 = require("./ae/AE");
const Leitung_1 = require("./leitung/Leitung");
const IA_1 = require("./ia/IA");
const Trommel_1 = require("./verpackung/Trommel");
class ArticleModelsMockCreator {
    static createKetteE4_56() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteE4_56);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    static createKetteH4_56() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteH4_56);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    static createKetteR4_56() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteR4_56);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    static createKetteE4_56_12_150() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteE4_56_12_150);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    static createKetteE6_80L_10_150() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteE6_80L_10_150);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    static createKetteE6_80L_15_150() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteE6_80L_15_150);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    /**
     * Creates E4.561.15.2.2.C.A AE for Kette E4.56.
     */
    static createAE_E4_56() {
        const ae = AE_1.AE.fromJson(echain_shared_articles_1.mockAE_E4_56);
        ae.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return ae;
    }
    /**
     * Creates E4.561.15.2.1.C.A AE for Kette E4.56.
     */
    static createAE2_E4_56() {
        const ae = AE_1.AE.fromJson(echain_shared_articles_1.mockAE2_E4_56);
        ae.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return ae;
    }
    static createKetteE6_29() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKetteE6_29);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    /**
     * Creates E6.290.100.2.A AE for Kette E6.29.
     */
    static createAE_E6_29() {
        const ae = AE_1.AE.fromJson(echain_shared_articles_1.mockAE_E6_29);
        ae.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return ae;
    }
    /**
     * Creates E6.290.100.1.A AE for Kette E6.29.
     */
    static createAE2_E6_29() {
        const ae = AE_1.AE.fromJson({
            ArtNr: { DE: 'E6.290.100.1.A' },
            Mitnehmer: false,
            Id: 269740021900,
            Montiert: true,
            GliedAnzahlAbhaengig: 0,
            Festpunkt: true,
        });
        ae.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return ae;
    }
    /**
     * Creates a CF140.10.07.UL Leitung with a length of 3000 mm.
     */
    static createSteuerleitung() {
        const leitung = Leitung_1.Leitung.fromJson(echain_shared_articles_1.mockSteuerleitung);
        leitung.leitungslaenge = echain_shared_quantities_1.Length.fromJson({ Value: 3000, Unit: 'mm' });
        leitung.ueberstandMitnehmer = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        leitung.ueberstandFestpunkt = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return leitung;
    }
    /**
     * Creates a CF140.10.07.UL Leitung with a length of 3100 mm.
     */
    static createSteuerleitung2() {
        const leitung = Leitung_1.Leitung.fromJson(echain_shared_articles_1.mockSteuerleitung2);
        leitung.leitungslaenge = echain_shared_quantities_1.Length.fromJson({ Value: 3100, Unit: 'mm' });
        leitung.ueberstandMitnehmer = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        leitung.ueberstandFestpunkt = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return leitung;
    }
    /**
     * Creates a CF240.01.03 Leitung with a length of 4000 mm.
     */
    static createDatenleitung() {
        const leitung = Leitung_1.Leitung.fromJson(echain_shared_articles_1.mockDatenleitung);
        leitung.leitungslaenge = echain_shared_quantities_1.Length.fromJson({ Value: 4000, Unit: 'mm' });
        leitung.ueberstandMitnehmer = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        leitung.ueberstandFestpunkt = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return leitung;
    }
    /**
     * Creates a CF885.15.04 Leitung with a length of 3500 mm.
     */
    static createMotorleitung() {
        const leitung = Leitung_1.Leitung.fromJson(echain_shared_articles_1.mockMotorleitung);
        leitung.leitungslaenge = echain_shared_quantities_1.Length.fromJson({ Value: 3500, Unit: 'mm' });
        leitung.ueberstandMitnehmer = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        leitung.ueberstandFestpunkt = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return leitung;
    }
    static createFreieLeitung4mm() {
        const leitung = Leitung_1.Leitung.fromJson(echain_shared_articles_1.mockFreieLeitung4mm);
        leitung.leitungslaenge = echain_shared_quantities_1.Length.fromJson({ Value: 2860, Unit: 'mm' });
        return leitung;
    }
    /**
     * Creates a 418 vertical IA for Kette E4.56.
     */
    static createFlatIa_E4_56() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_E4_56);
    }
    /**
     * Creates a E6.29.11 vertical IA for Kette E6.29.
     */
    static createFlatIa_E6_29_11() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_E6_29_11);
    }
    /**
     * Creates a E6.29.11.R vertical IA for Kette E6.29.
     */
    static createFlatIa_E6_29_11_R() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_E6_29_11_R);
    }
    /**
     * Creates a E6.29.12 vertical IA for Kette E6.29.
     */
    static createFlatIa_E6_29_12() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_E6_29_12);
    }
    /**
     * Creates a 29.1.1 vertical IA for Kette E6.29.
     */
    static createRoundIa_E6_29__29_1_1() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockRoundIa_E6_29__29_1_1);
    }
    /**
     * Creates a E6.29.13 Seitenplatte for Kette E6.29.
     */
    static createSeitenplatteIa_E6_29_13() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockSeitenplatteIa_E6_29_13);
    }
    /**
     * Creates a 111.60 horizontal IA for Kette E6.29.
     */
    static createSmallEinsteckbodenIa_E6_29() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockSmallEinsteckbodenIa_E6_29);
    }
    /**
     * Creates a 111.100 horizontal IA for Kette E6.29.
     */
    static createEinsteckbodenIa_E6_29() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockEinsteckbodenIa_E6_29);
    }
    /**
     * Creates a 2210.18 horizontal IA for Kette E6.29.
     */
    static createFachbodenIa_E6_29__2210_18() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFachbodenIa_E6_29__2210_18);
    }
    /**
     * Creates a 2210.23 horizontal IA for Kette E6.29.
     */
    static createFachbodenIa_E6_29__2210_23() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFachbodenIa_E6_29__2210_23);
    }
    /**
     * Creates a 2210.33 horizontal IA for Kette E6.29.
     */
    static createFachbodenIa_E6_29__2210_33() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFachbodenIa_E6_29__2210_33);
    }
    /**
     * Creates a 2310.025 horizontal IA for Kette E6.29.
     */
    static createUniversalbodenIa_E6_29__2310_025() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockUniversalbodenIa_E6_29__2310_025);
    }
    /**
     * Creates a 2310.050 horizontal IA for Kette E6.29.
     */
    static createUniversalbodenIa_E6_29__2310_050() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockUniversalbodenIa_E6_29__2310_050);
    }
    /**
     * Creates a B17 Kette domain object.
     */
    static createKette_B17_2_063() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKette_B17_2_063);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    /**
     * Creates a 400 Kette domain object.
     */
    static createKette_400_20_135_0() {
        const kette = Kette_1.Kette.fromJson(echain_shared_articles_1.mockKette_400_20_135_0);
        kette.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 2000, Unit: 'mm' });
        const ketteConfigurationBuilder = new KetteConfigurationBuilder_1.KetteConfigurationBuilder();
        ketteConfigurationBuilder.buildByLaenge(kette, kette.laenge);
        return kette;
    }
    /**
     * Creates 4000.20.2.1.A AE for Kette B17.
     */
    static createAe_4000_20_2_1_A() {
        const ae = AE_1.AE.fromJson(echain_shared_articles_1.mockAe_4000_20_2_1_A);
        ae.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return ae;
    }
    /**
     * Creates 4000.20.2.2.A AE for Kette B17.
     */
    static createAe_4000_20_2_2_A() {
        const ae = AE_1.AE.fromJson(echain_shared_articles_1.mockAe_4000_20_2_2_A);
        ae.laenge = echain_shared_quantities_1.Length.fromJson({ Value: 10, Unit: 'mm' });
        return ae;
    }
    /**
     * Creates a 413 vertical IA for Kette 400.
     */
    static createFlatIa_413() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_413);
    }
    /**
     * Creates a 418 vertical IA for Kette 400.
     */
    static createFlatIa_418() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_418);
    }
    /**
     * Creates a 56.3.1 vertical IA for Kette 400.
     */
    static createFlatIa_56_3_1() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockFlatIa_56_3_1);
    }
    /**
     * Creates a 421.50 horizontal IA for Kette 400.
     */
    static createZwischenbodenIa_421_50() {
        return IA_1.IA.fromJson(echain_shared_articles_1.mockZwischenbodenIa_421_50);
    }
    /**
     * Creates a MAT0178542 Verpackung Trommel for Kette 400.
     */
    static createVerpackungTrommel_MAT0178542() {
        return Trommel_1.Trommel.fromJson(echain_shared_articles_1.mockVerpackungTrommel_MAT0178542);
    }
}
exports.ArticleModelsMockCreator = ArticleModelsMockCreator;
//# sourceMappingURL=ArticleModelsMockCreator.js.map